import { ConnectButton } from '@rainbow-me/rainbowkit';
import { AppSidebar } from "@/components/app-sidebar";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/breadcrumb";
import { Separator } from "@/components/separator";
import {
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
} from "@/components/sidebar";
import { Button } from "@/components/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/card";
import { Link } from "react-router-dom";
import {
  RiPlantLine,
  RiCoinsLine,
  RiAddLine,
  RiTimeLine,
  RiRocketLine
} from "@remixicon/react";

// Farming pairs configuration
const farmingPairs = [
  {
    id: "LRS-USD",
    token1: { symbol: "LRS", color: "#FF8A3C" },
    token2: { symbol: "USD", color: "#26A17B" },
    name: "LRS/USD",
    description: "Larissa / Tether USD",
  },
  /*{
    id: "LRS-LRSN",
    token1: { symbol: "LRSN", color: "#8B5CF6" },
    token2: { symbol: "LRS", color: "#FF8A3C" },
    name: "LRSN/LRS",
    description: "Larissa Network Token / Larissa",
  },
  {
    id: "SILO-LRS",
    token1: { symbol: "SILO", color: "#10B981" },
    token2: { symbol: "LRS", color: "#FF8A3C" },
    name: "SILO/LRS",
    description: "Silo / Larissa",
  },*/
];

export default function FarmingPage() {
  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <div className="px-4 md:px-6 lg:px-8 @container">
          <div className="w-full max-w-6xl mx-auto">
            <header className="flex flex-wrap gap-3 min-h-20 py-4 shrink-0 items-center transition-all ease-linear border-b">
              <div className="flex flex-1 items-center gap-2">
                <SidebarTrigger className="-ms-1" />
                <div className="max-lg:hidden lg:contents">
                  <Separator
                    orientation="vertical"
                    className="me-2 data-[orientation=vertical]:h-4"
                  />
                  <Breadcrumb>
                    <BreadcrumbList>
                      <BreadcrumbItem className="hidden md:block">
                        <BreadcrumbLink asChild>
                          <Link to="/">Home</Link>
                        </BreadcrumbLink>
                      </BreadcrumbItem>
                      <BreadcrumbSeparator className="hidden md:block" />
                      <BreadcrumbItem>
                        <BreadcrumbLink asChild>
                          <Link to="/blockchain">Blockchain</Link>
                        </BreadcrumbLink>
                      </BreadcrumbItem>
                      <BreadcrumbSeparator className="hidden md:block" />
                      <BreadcrumbItem>
                        <BreadcrumbPage>Farming</BreadcrumbPage>
                      </BreadcrumbItem>
                    </BreadcrumbList>
                  </Breadcrumb>
                </div>
              </div>
              <ConnectButton />
            </header>

            <div className="py-6">
              <div className="flex items-center mb-6">
                <div className="w-1 h-8 bg-[#FF8A3C] mr-3"></div>
                <h1 className="text-3xl font-bold">Farming</h1>
              </div>

              <div className="w-full max-w-xs h-1 bg-gradient-to-r from-[#FF8A3C] to-transparent mb-8 rounded-full"></div>

              <Card className="bg-[#FF8A3C]/10 border border-[#FF8A3C]/30 mb-6">
                <CardContent className="p-6">
                  <div className="flex items-start gap-4">
                    <RiRocketLine className="size-8 text-[#FF8A3C] flex-shrink-0 mt-0.5" />
                    <div className="flex-1">
                      <h3 className="text-xl font-semibold text-[#FF8A3C] mb-2">Farming Coming Soon!</h3>
                      <p className="text-sm text-foreground/80 mb-3">
                        Exciting farming opportunities are on the way! Stake your LP tokens to earn rewards across multiple farming pairs.
                      </p>
                      <div className="flex flex-wrap gap-2">
                        {farmingPairs.map((pair) => (
                          <span
                            key={pair.id}
                            className="px-3 py-1 bg-background border border-border rounded-full text-xs font-medium"
                          >
                            {pair.name}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <div className="space-y-8">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  <Card className="bg-sidebar border border-border">
                    <CardContent className="p-6">
                      <div className="flex items-center">
                        <div className="w-1 h-10 bg-[#FF8A3C] mr-3"></div>
                        <div>
                          <div className="text-sm text-muted-foreground">Total Value Locked</div>
                          <div className="text-2xl font-bold text-muted-foreground">Coming Soon</div>
                        </div>
                      </div>
                    </CardContent>
                  </Card>

                  <Card className="bg-sidebar border border-border">
                    <CardContent className="p-6">
                      <div className="flex items-center">
                        <div className="w-1 h-10 bg-[#FF8A3C] mr-3"></div>
                        <div>
                          <div className="text-sm text-muted-foreground">Average APR</div>
                          <div className="text-2xl font-bold text-muted-foreground">Coming Soon</div>
                        </div>
                      </div>
                    </CardContent>
                  </Card>

                  <Card className="bg-sidebar border border-border">
                    <CardContent className="p-6">
                      <div className="flex items-center">
                        <div className="w-1 h-10 bg-[#FF8A3C] mr-3"></div>
                        <div>
                          <div className="text-sm text-muted-foreground">Active Farms</div>
                          <div className="text-2xl font-bold">Coming Soon</div>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </div>

                <Card className="bg-sidebar border border-border">
                  <CardHeader>
                    <CardTitle className="flex items-center gap-2">
                      <RiPlantLine className="size-5 text-[#FF8A3C]" />
                      Farming Pairs
                    </CardTitle>
                    <CardDescription>Liquidity mining opportunities</CardDescription>
                  </CardHeader>
                  <CardContent>
                    <div className="space-y-4">
                      {farmingPairs.map((pair) => (
                        <div
                          key={pair.id}
                          className="relative p-6 rounded-lg bg-background border border-border overflow-hidden"
                        >
                          <div className="absolute top-4 right-4 z-10">
                            <div className="flex items-center gap-2 px-3 py-1.5 bg-[#FF8A3C] text-white rounded-full text-xs font-semibold shadow-lg">
                              <RiTimeLine className="size-3.5" />
                              Coming Soon
                            </div>
                          </div>

                          <div className="opacity-60">
                            <div className="flex flex-col md:flex-row justify-between gap-6">
                              <div className="flex items-start gap-4">
                                <div className="relative flex-shrink-0">
                                  <div
                                    className="h-12 w-12 rounded-full flex items-center justify-center font-bold text-sm shadow-md"
                                    style={{
                                      backgroundColor: `${pair.token1.color}20`,
                                      color: pair.token1.color,
                                    }}
                                  >
                                    {pair.token1.symbol}
                                  </div>
                                  <div
                                    className="h-8 w-8 rounded-full flex items-center justify-center font-bold text-xs shadow-md absolute -bottom-1 -right-1 border-2 border-background"
                                    style={{
                                      backgroundColor: `${pair.token2.color}20`,
                                      color: pair.token2.color,
                                    }}
                                  >
                                    {pair.token2.symbol}
                                  </div>
                                </div>

                                <div>
                                  <h3 className="text-lg font-semibold mb-1">{pair.name}</h3>
                                  <p className="text-sm text-muted-foreground mb-3">{pair.description}</p>
                                  <div className="flex flex-wrap items-center gap-4 text-sm">
                                    <div className="flex items-center gap-1.5">
                                      <span className="text-muted-foreground">APR:</span>
                                      <span className="font-medium">TBA</span>
                                    </div>
                                    <span className="text-muted-foreground">•</span>
                                    <div className="flex items-center gap-1.5">
                                      <span className="text-muted-foreground">TVL:</span>
                                      <span className="font-medium">Coming Soon</span>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="flex flex-col sm:flex-row items-stretch gap-2 min-w-[280px]">
                                <Button
                                  variant="outline"
                                  className="flex-1"
                                  disabled
                                >
                                  <RiAddLine className="mr-1 size-4" />
                                  Stake
                                </Button>
                                <Button
                                  variant="outline"
                                  className="flex-1"
                                  disabled
                                >
                                  <RiCoinsLine className="mr-1 size-4" />
                                  Claim
                                </Button>
                              </div>
                            </div>

                            <div className="mt-6 pt-6 border-t border-border">
                              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                                <div>
                                  <div className="text-xs text-muted-foreground mb-1">Your Staked</div>
                                  <div className="font-medium text-sm">-- LP Tokens</div>
                                </div>
                                <div>
                                  <div className="text-xs text-muted-foreground mb-1">Your Share</div>
                                  <div className="font-medium text-sm">--%</div>
                                </div>
                                <div>
                                  <div className="text-xs text-muted-foreground mb-1">Earned Rewards</div>
                                  <div className="font-medium text-sm">-- LRS</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </CardContent>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
}





